import { ApiValidationError } from 'contracts/Common';
import type { FindSchedulingDocks, SchedulingDock } from 'contracts/Scheduling';
import update from 'immutability-helper';
import { createActions, createReducer } from 'reduxsauce';

const { Types, Creators } = createActions(
  {
    request: ['query', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'LIST_SCHEDULING_DOCKS_',
  }
);

export interface ListSchedulingDocksState {
  data: SchedulingDock[];
  loading: boolean;
  errorMessage: string | null;
  validationErrors: ApiValidationError[];
}

export interface ListSchedulingDocksRequestAction {
  query: FindSchedulingDocks;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: SchedulingDock[];
}

interface FailureAction {
  errorMessage: string;
  validationErrors?: ApiValidationError[];
}

const INITIAL_STATE: ListSchedulingDocksState = {
  data: [],
  loading: false,
  errorMessage: null,
  validationErrors: [],
};

const request = (state: ListSchedulingDocksState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
    validationErrors: { $set: [] },
  });

const success = (state: ListSchedulingDocksState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: ListSchedulingDocksState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
    validationErrors: { $set: action.validationErrors || [] },
  });

const softReset = (state: ListSchedulingDocksState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const listSchedulingDocks = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const ListSchedulingDocksTypes = Types;
export const ListSchedulingDocksActions = Creators;
